import {
  type ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useAccount } from 'wagmi';
import PreLoader from '../components/PreLoader';

interface WalletInitializationContextType {
  isWalletInitialized: boolean;
}

const WalletInitializationContext =
  createContext<WalletInitializationContextType>({
    isWalletInitialized: false,
  });

export function WalletInitializationProvider({
  children,
}: { children: ReactNode }) {
  const [isWalletInitialized, setIsWalletInitialized] = useState(false);
  const { isConnected, isDisconnected } = useAccount();

  useEffect(() => {
    if (isConnected || isDisconnected) {
      setIsWalletInitialized(true);
    }
  }, [isConnected, isDisconnected]);

  if (!isWalletInitialized) {
    return <PreLoader />;
  }

  return (
    <WalletInitializationContext.Provider value={{ isWalletInitialized }}>
      {children}
    </WalletInitializationContext.Provider>
  );
}

export const useWalletInitialization = () =>
  useContext(WalletInitializationContext);
